module.exports = __webpack_public_path__ + "static/media/archive3.5dc54ed5.jpeg";